import { adminListingQueryKeys as e } from "./adminListingQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminListingsApi as r } from "@maat/api-main";
//#region src/listings/admin/useAdminUpdateUnitDetailsMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, ...t }) => r.updateUnitDetails(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.detail().slice(0, 1) });
		}
	});
};
//#endregion
export { i as useAdminUpdateUnitDetailsMutation };
